import React from 'react';

const CallToAction = () => {
  return (
    <section className="cta" id="demo">
      <div className="container">
        <h2>Ready to take your manufacturing to the next level?</h2>
        <p>Request a free demo today and discover how WorkflowNL can transform your production processes.</p>
        <a href="#contact" className="btn">Request Free Demo</a>
      </div>
    </section>
  );
};

export default CallToAction;